if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    bindVariantMainInputChange();
  }, 2000);

  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList)
      for (let item of MutationList) {
        if (item.target.classList.contains("cart__total") || item.target.classList.contains("search-results-container")) {
          handleCartDrawerFooterMutation();
        }
        if (item.target.localName === 'cart-form') {
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        }     
        if (item.target.classList.contains("modal-content")) {
          document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
          setTimeout(() => {
            bindVariantQuickviewInputChange();
          }, 500);
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);

  async function handleCartDrawerFooterMutation() {
    if (BSS_B2B) {
      const res = await BSS_B2B.storage.productStorage.load();
      if (res) {
        if (
          res.notExistProductIds?.length ||
          res.productIds?.length ||
          res.variantIds?.size
        ) {
          BSS_B2B.observer.productSubject.notifyObserver(
            "LazyProduct",
            "LoadedLazyProduct",
            {
              ...res,
            }
          );
        }
      }
    }
  }
  function bindVariantQuickviewInputChange() {
    const variantInputs = document.querySelectorAll(
      ".product-variant__item input"
    );
    if (variantInputs.length) {
      variantInputs.forEach((item) => {
        item.addEventListener("click", (e) => {
          const productForm = document.querySelector(
            "[bss-b2b-quickview-product-form]"
          );
          BSS_B2B.observer.productSubject.notifyObserver(
            "VariantChange",
            "VariantSelectChange",
            { event: e, productForm }
          );
        });
      });
    }
  }
  function bindVariantMainInputChange() {
    const variantInputs = document.querySelectorAll(
      "[bss-b2b-main-product-form] .product-variant__item input"
    );
    if (variantInputs.length) {
      variantInputs.forEach((item) => {
        item.addEventListener("click", (e) => {
          const productForm = document.querySelector(
            "[bss-b2b-main-product-form]"
          );
          BSS_B2B.observer.productSubject.notifyObserver(
            "VariantChange",
            "VariantSelectChange",
            { event: e, productForm }
          );
        });
      });
    }
  }
}
